import { Component, OnInit, Input, Output, EventEmitter, Injector, ViewChild, ElementRef } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { ModalSize } from 'src/modules/base/services/smart-modal.service';
import { Router, ActivatedRoute ,NavigationEnd} from '@angular/router';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { SmartModalService } from 'src/modules/base/services/smart-modal.service';
import { ImageUploadPopupComponent } from 'src/modules/kx-shared/components/image-upload-popup/image-upload-popup.component';
import { PopupFormComponent } from 'src/modules/base/components/popupform/popupform.component';
import { CommunicationService } from 'src/modules/base/services/communication.service';
import { PopUpOverGridWithControlsComponent } from 'src/modules/base/components/dynamic-Grid-with-control/pop-up-over-grid-with-controls/pop-up-over-grid-with-controls.component';
import { DialogModalSize } from 'src/modules/base/components/dialog/dialog-ref';
import { RolePermissionService } from 'src/modules/base/shared/services/role-permission.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { PreferenceService } from 'src/modules/base/shared/services/preference.service';
import { DialogService } from 'src/modules/base/components/dialog/dialog.service';
import { AdvanceSearchComponent } from 'src/modules/base/components/advance-search/advance-search.component';
import { PopUIEngineComponent } from 'src/modules/base/components/pop-uiengine/pop-uiengine.component';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { AIService } from 'src/modules/base/components/aiml/services/ai.service';
import { ArtPatientLayoutService } from './artpatientlayout.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';
import { HealthAnalysisComponent } from '../../health-analysis/health-analysis.component';

declare var jQuery: any;

@Component({
    selector: 'app-patient-layout',
    templateUrl: './patient-layout.component.html',
    styleUrls: ['./patient-layout.component.scss'],
    standalone: false
})
export class PatientLayoutComponent implements OnInit {
  @Input() dataForCard: Array<any>;
  @Input() bannerJson: any;
  @Output() footerLinksClick: EventEmitter<any> = new EventEmitter();
  @Output() elementInfo = new EventEmitter<any>();
  cardData: any;
  docData: any;
  imageURL = '';
  data: any;
  selectedFiles: Array<any> = [];
  imageSrc: any;
  file: FileList;
  file_id: string;
  uploadImage: boolean = false;
  documentId: any;
  bannerApp: any;
  bannerQuery: any;
  id: string;
  bannerRes: any;
  resource: any;
  cacheObj: any;
  action: any;
  jsonFields: Array<any> = [];
  supportingFields: Array<any> = [];
  expandCard: boolean = false;
  addTableClass: boolean = false;
  resourcename: any;
  private pharmacyCacheKey: string;
  private cashCacheKey : string;
  @ViewChild('bannerContainer') elementView: ElementRef;
  divOpacity: number = 0;

  config:any = {notAllowedActions:[],configLoaded:false,showLink:false};
  isInfection: boolean = false;
  remarksInfection = []
  public aiSummary:any={resourceDef:{},load:false};
  public aiService:AIService;
  showIvfBanner = false;
  private routerSub!: Subscription;
  extra_buttons: any;
  showMdrIcon: boolean = false;

  constructor(
    public injector: Injector,
    public router: Router,
    public route: ActivatedRoute,
    public alerts: AlertsService,
    public baseService: BaseService,
    public smartModalService: SmartModalService,
    public communicationService: CommunicationService,
    public rolePermissionService: RolePermissionService,
    public preferenceService: PreferenceService,
    public utilService: UtilService,
    public dialogService?: DialogService,
    public appService?: AppService,
    private loaderService?: LoaderService,
    public artPatientLayoutService?:ArtPatientLayoutService
  ) {
    this.aiService = injector.get(AIService);
   }

  calculateDivHeight() {
    if (!this.bannerJson.expandable || this.bannerJson.divHeight != undefined) {
      if (this.elementView != undefined && this.bannerJson.oldWidth != undefined && this.bannerJson.oldWidth != this.elementView.nativeElement.offsetWidth) {
        this.bannerJson.expandable = true;
        this.expandCard = false;
      } else {
        this.bannerJson.expandable = false;
        this.expandCard = false;
      }
      this.bannerJson.divHeight = true;
    }
  }

  ngAfterViewChecked() {
    // this.calculateDivHeight();
  }

  redirectDiagnostic() {
    const tabId = "newDiagnosticReport";
    // the tab is owned by ui-engine, it keeps the active tab in _layout_id and only reads
    // tab_0 from the url on init - so clicking the tab itself does the real switch
    const tabElement = document.getElementById(tabId);
    if (tabElement) {
      tabElement.click();
      return;
    }
    // tab not rendered yet, keep the current url as is and reload it on the diagnostic report tab
    const urlTree = this.router.parseUrl(this.router.url);
    urlTree.queryParams = { ...urlTree.queryParams, tab_0: tabId };
    delete urlTree.queryParams["tab_1"];
    delete urlTree.queryParams["tab_2"];
    delete urlTree.queryParams["layout"];
    delete urlTree.queryParams["p__no"];
    const prevReuse = this.router.routeReuseStrategy.shouldReuseRoute;
    const prevOSN = this.router.onSameUrlNavigation;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = "reload";
    this.router.navigateByUrl(urlTree).then(() => {
      this.router.routeReuseStrategy.shouldReuseRoute = prevReuse;
      this.router.onSameUrlNavigation = prevOSN;
    });
  }

  ngOnInit() {
    if (this.bannerJson?.key?.ivf_no  && this.bannerJson?.key?.emr_type_flow_code &&this.bannerJson?.key?.emr_type_flow_code=='art_consultation') {
      this.routerSub = this?.router?.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.showIvfBanner = this.artPatientLayoutService?.checkIvfBannerVisibility(event.urlAfterRedirects);
      });
    // initial level check
    this.showIvfBanner = this.artPatientLayoutService?.checkIvfBannerVisibility(this.router.url);
    this.artPatientLayoutService.checkAndStorePrimaryEncounter(this.bannerJson,() => this.artPatientLayoutSetup());    
  }
    this.getBannerPreference();
    setTimeout(()=>{
      if(this.bannerJson.resouceDef != undefined){
        if(this.bannerJson.resouceDef?.config?.extra_buttons?.buttons != undefined){
          this.extra_buttons = this.bannerJson.resouceDef.config.extra_buttons.buttons;
        }
        /******** AI SUMMARY ****************/
        this.aiService.checkIfAIAvailable(this.bannerJson.resouceDef,AIService.AI_SUMMARY,(aiResp)=>{
          if(this.bannerJson.resouceDef.config?.ai != undefined){
            this.aiSummary.resourceDef = aiResp;
            this.aiSummary.dynamic_key = "*";
            this.aiSummary.load = true;
            this.aiSummary.filter = "uhId:"+this.dataForCard[0].uhId;
            const showPopup = this.bannerJson.resouceDef.config?.ai?.showPopup;
            if (showPopup && typeof showPopup === 'object' && !Array.isArray(showPopup)) {
              this.aiSummary.showPopup = this.bannerJson.resouceDef.config.ai.showPopup
              this.aiSummary.showPopup.data = this.dataForCard[0]
              this.aiSummary.showPopup.banner = { 'key': this.dataForCard[0] }
              this.aiSummary.showPopup.size = DialogModalSize.Lg
              // this.aiSummary.showPopup = {
              //   resource: "episode_summary",
              //   action: "LIST",
              //   data: this.dataForCard[0],
              //   'banner': { 'key': this.dataForCard[0]},
              //   // data: {
              //   //   'resource': "episode_summary",
              //   //   'bannerJson': { 'key': this.dataForCard[0], 'datasource': {} },
              //   // },
              //   config: {
              //     "customButtonsAllowed": true,
              //     "disableCapability":false,
              //     "allowPagination":true,
              //     "search":true,
              //     "hideSearchBox": false,
              //   },
              //   title: "Select Episodes To Generate Summary",
              //   size: DialogModalSize.Lg
              // }
            }
            if(this.dataForCard[0].encounter_id != undefined){
              this.aiSummary.filter += ",encounter_id:"+this.dataForCard[0].encounter_id;
            }
           }       
        });
       /******** AI SUMMARY ****************/
      }
    })
    console.log("Data For Card is ", this.dataForCard, this.bannerJson);
    if (window.location.href.includes('billingDesign') || window.location.href.includes('banner_changes') || window.location.href.includes('banner_change')) {
      this.bannerJson.billingDesign = true;
    }
    if (this.bannerJson && this.bannerJson.expandable == undefined) {
      this.bannerJson.expandable = true;
    }
    if (this.bannerJson.profile_key == undefined)
      this.bannerJson.profile_key = 'profile_id'
    if (this.route.snapshot.data.resource == 'billing_format_ip' || this.route.snapshot.data.resource == 'settled_format_ip' || this.route.snapshot.data.resource == 'banner_details_settement' || this.route.snapshot.data.resource == 'discharge_patientupdate_banner') {
      this.communicationService.emitChange({ hideMenuIcon: true });

    }
    if (this.bannerJson.jsonFields != undefined) {
      this.jsonFields = this.bannerJson.jsonFields.fields.sort((a, b) => { return a.order - b.order });
    }
    //for emr show latest health score
    if (this.jsonFields && this.dataForCard?.length > 0 && this.dataForCard[0].latest_health_score != undefined) {
      let obj = {
        "heading": "field.label.health_score",
        "card_tag": "tag7",
        "field_name": "TextView",
        "order": this.jsonFields.length - 1,
        "sortable": true,
        "banner_popover_data": "latest_health_problem_status",
        "name": "latest_health_score",
        "showheading": true
      }
      if (this.dataForCard[0].health_score_color != undefined) {
        obj["style"] = this.dataForCard[0].health_score_color ? this.dataForCard[0].health_score_color : false
      }
      this.jsonFields.push(obj);
    }
    if (this.bannerJson.supportingFields != undefined) {
      this.supportingFields = this.bannerJson.supportingFields.fields.sort((a, b) => { return a.order - b.order });
    }
    if(this.bannerJson && this.bannerJson.comorbidityData && this.bannerJson.comorbidityData.length>0){
      this.bannerJson.comorbidityData = this.bannerJson.comorbidityData.filter((x)=>x.noKnownComorbidity != true )
    }

    let link = this.jsonFields.find(val => {
      return val.name == 'link';
    });
    if (link != undefined) {
      if (link.config != undefined) {
        if (link.permission_required)
          this.config.showLink = true;
        else if (link.permission_required == undefined || !link.permission_required)
          this.addTableClass = true;
      }
    }
    var data = this.dataForCard[0];
    if(data){
      this.checkNotePermission(data);
    }
    if (this.dataForCard != undefined && this.dataForCard) {
      if(data && data[this.bannerJson.profile_key]!=undefined){
        this.file_id = data[this.bannerJson.profile_key];
      }
      this.id = data.id;
      this.action = this.route.snapshot.data.action;
      this.resource = this.route.snapshot.data.resource;
      console.log("RESOURCE NAME ::", this.resource);
      if (this.dataForCard[0] && this.dataForCard[0].tag_data && !this.bannerJson.hide_patient_tags) {
        this.bannerJson.tag_data = this.dataForCard[0].tag_data;
        this.bannerJson.visibleTag = this.bannerJson.tag_data.find(val => {
          return val.visible === true;
        });
        if(this.bannerJson.visibleTag != undefined)
          document.getElementById("core-body").classList.add('_pb-tags');
      }
    }
  }
  artPatientLayoutSetup(): void {
    if (this.bannerJson?.key?.encounter_id) {
      let prescriptionSentStatus=false;
        if(this.bannerJson?.key?.prescription_sent)
        {
         prescriptionSentStatus=true; 
        }
      this.artPatientLayoutService.storeMappedPatient( this.bannerJson.key.uhId, this.bannerJson.key.encounter_id, this.bannerJson.key.id, this.bannerJson.key.patient_name , prescriptionSentStatus,this.bannerJson?.key?.stage);
    }
    if (this.bannerJson?.key?.ivf_no && this.bannerJson?.key?.emr_type_flow_code=='art_consultation') {
      let ivf_no = this.bannerJson.key.ivf_no
      const args = "ivf_no:" + ivf_no
      this.artPatientLayoutService.getIVFData(args, true, (ivfData) => {
        if (ivfData && ivfData.length > 0) {
          this.bannerJson.IVFData_active = ivfData;
        }
      });
    }
  }
  /**
   * - Opens a modal dialog using `PopUIEngineComponent` with the configured data.
   */
  showBedHistory() {
    let popobj = {
      data: {
        'resourceDef': "",
      }, title: "View Bed History", size: DialogModalSize.Lg
    };
    this.baseService.getResourceDef("emr_ip_bed_transfer_detail", (resouceDef) => {
      if (resouceDef && this.action == 'ADD' && resouceDef.form) {
        resouceDef.form.datasource = {
          "application": "adt",
          "resource": "encounter_transfer",
          "query_id": "GET_APPROVED_BED_TRANSFERS",
          "args": "encounter_id:!!!encounter_id!!!"
        }
      }
      popobj.data['resourceDef'] = resouceDef
      this.dialogService.open(PopUIEngineComponent, popobj).afterClosed.subscribe(
        response => {
        })
    })
  }
  viewPatientDetails() {
    let popobj = {
      data: {
        'resourceDef': "",
      }, title: "View Patient Details", size: DialogModalSize.Lg
    };
    this.baseService.getResourceDef("view_patient_details", (resouceDef) => {
      if (resouceDef && this.action == 'ADD' && resouceDef.form) {
        resouceDef.form.datasource = {
          "application": "patient-registration",
          "resource": "patient",
          "query_id": "GET_BY_ID",
          "args": "id:!!!id!!!"
        }
      }
      popobj.data['resourceDef'] = resouceDef
      this.dialogService.open(PopUIEngineComponent, popobj).afterClosed.subscribe(
        response => {
          //console.log("popup is closed");
          //this.router.navigate([])
        })
    })
  }
  checkNotePermission(data) { //check permission to view patient note from banner
    let notePermission = this.rolePermissionService.checkAccessPermission('viewNoteBanner', 'self_note', 'emr')
    if(notePermission){
      let args = "uhId:" + data.uhId + ",encounter_id:" + data.encounter_id + ",episode_id:" + (data.encounter_id ? data.encounter_id : data.episode_id);
      this.baseService.get('GET_SELFNOTE_BY_USERID', args, 'self_note', 'emr',"status:Active").subscribe((res: any) => {
        if (res.errCode == 0 && res.resource.length > 0)
          this.bannerJson.viewNote = {action:"viewNoteBanner"}
      });
    }
  }
  ngAfterViewInit() {
    this.divOpacity = 0;
    this.expandCard = true;
    this.getTagsandFile();
  }
  addendumclick(json, data) {
    this.footerLinksClick.emit({ data });
  }
  getTagsandFile() {
    var data = this.dataForCard[0];
    if (data != undefined) {
      let args = ''
      if (data.uhId != undefined && data.encounter_id != undefined) {
        args = "uhId:" + data.uhId + ",encounter_id:" + data.encounter_id;
      } else if (data.uhId != undefined && data.orderId != undefined && data.orderId != '') {
        args = "uhId:" + data.uhId + ",orderId:" + data.orderId;
      } else if (data.uhId != undefined && data.serviceRequestId != undefined && data.serviceRequestId != '') {
        args = "uhId:" + data.uhId + ",serviceRequestId:" + data.serviceRequestId;
      } else if (data.uhId != undefined && data.admissionId != undefined && data.admissionId != '') {
        args = "uhId:" + data.uhId + ",orderId:" + data.admissionId;
      } else {
        args = "uhId:" + data.uhId;
      }
      if (this.bannerJson && this.bannerJson.datasource && this.bannerJson.datasource.show_deposit_uhid) {
        this.bannerRes = "deposit_uhId"
        this.bannerApp = "payment"
        this.bannerQuery = "GET_BY_ID"
        args = "facility_id:" + data.facility_id + ",id:" + data.id;
      }
      else if(this.bannerJson && this.bannerJson.datasource && this.bannerJson.datasource.restrict_get_banner){
        this.bannerRes = this.bannerJson.datasource.resource
        this.bannerApp = this.bannerJson.datasource.application
        this.bannerQuery = this.bannerJson.datasource.query_id
        args = "id:" + data.id;
      }
      else {
        this.bannerRes = "encounter"
        this.bannerApp = "adt"
        this.bannerQuery = "GET_BANNER_DATA"
      }
      this.baseService.get(this.bannerQuery, args, this.bannerRes, this.bannerApp).subscribe(
        (res: any) => {
          if (res.errCode == 0 && res.resource.length > 0) {
            if (res.resource[0].g_creation_time)
              delete res.resource[0].g_creation_time;
            if (this.dataForCard[0].vulnerable != undefined)
              delete this.dataForCard[0].vulnerable;
            const tag1 = Array.isArray(res.resource?.[0]?.tag_data)
              ? res.resource[0].tag_data
              : [];

            const tag2 = Array.isArray(this.dataForCard?.[0]?.tag_data)
              ? this.dataForCard[0].tag_data
              : Object.values(this.dataForCard?.[0]?.tag_data || {});

            // billing's payer_details overrides the API's (same key) in the merge: with the flag, keep the API's list as banner_additional_payer_details
            const bannerPayerDetails = res.resource?.[0]?.payer_details;
            this.dataForCard[0] = {
              ...res.resource?.[0],
              ...this.dataForCard?.[0],
              ...(this.bannerJson?.resouceDef?.config?.enable_extra_payer_details_fallback === true ? { banner_additional_payer_details: bannerPayerDetails } : {}),
              tag_data: [
                ...new Map(
                  [...tag1, ...tag2]
                    .filter(tag => tag && (tag.id || tag.key_name))
                    .map(tag => [tag.id || tag.key_name, tag])     
                ).values()
              ]
            };
            if (this.dataForCard[0].hwc_remark) {
              this.bannerJson.hwc_remark = this.dataForCard[0].hwc_remark;
            } else if (this.dataForCard[0].extra_data && this.dataForCard[0].extra_data.hwc_remarks) {
              this.bannerJson.hwc_remark = this.dataForCard[0].extra_data.hwc_remarks;
            }
            if (this.dataForCard[0].tag_data) {
              this.bannerJson.tag_data = this.dataForCard[0].tag_data;
            }
            if (res.resource[0][this.bannerJson.profile_key] != '' && res.resource[0][this.bannerJson.profile_key] != undefined) {
              this.file_id = res.resource[0][this.bannerJson.profile_key];
              this.getProfileData(this.file_id);
            }
            if(this.dataForCard[0].prolonged_stay_remark != undefined && this.dataForCard[0].prolonged_stay_remark != ''){

            }
            if (this.dataForCard[0].mdr != undefined && this.dataForCard[0].mdr != '') {
              this.showMdrIcon = this.dataForCard[0].mdr;
            }
            if (this.dataForCard[0].infection_flags && Object.keys(this.dataForCard[0].infection_flags).length > 0) {
              let remarks;
              if(this.dataForCard[0]?.infection_details_remarks){
                remarks = Object.entries(this.dataForCard[0]?.infection_details_remarks).map(([key, value]) => ({ [key]: value }));
              }
              this.remarksInfection = Object.entries(this.dataForCard[0]?.infection_flags).map(([key, value]) => ({ [key]: value }));
              this.remarksInfection?.forEach((element,index) => {
                remarks?.forEach(el => {
                  if(Object.keys(element)[0].substring(0, 3) == Object.keys(el)[0].substring(0,3)){
                    this.remarksInfection[index]['remarks'] = el[Object.keys(el)[0]]
                  }
                });
                if(Object.keys(element)[0] == 'hospital_acquired_infection'){
                  this.remarksInfection[index]['remarks'] = ""
                }
                if(Object.keys(element) && element[Object.keys(element)[0]]){
                  this.isInfection = true;
                  this.remarksInfection[index]['name']=Object.keys(element)[0]
                }
              });
            }
          }
          else if (this.dataForCard[0][this.bannerJson.profile_key] != '' && this.dataForCard[0][this.bannerJson.profile_key] != undefined) {
            this.file_id = this.dataForCard[0][this.bannerJson.profile_key];
            this.getProfileData(this.file_id);
          }
          if (this.elementView != undefined) {
            this.bannerJson.oldHeight = this.elementView.nativeElement.offsetHeight;
            this.bannerJson.oldWidth = this.elementView.nativeElement.offsetWidth;
            if (this.bannerJson.oldHeight > 113) {
              this.bannerJson.expandable = true;
              this.expandCard = false;
            } else {
              this.bannerJson.expandable = false;
              this.expandCard = false;
            }
            this.divOpacity = 1;
          }
        });
    }
  }
  getValue(value, item) {
    if (value != undefined && item != undefined && eval(value) != undefined) {
      return eval(value);
    };
  }
  checkIfUrl(key_val){
    if(key_val && (key_val.includes('http') || key_val.includes('https'))){
      return true;
    }else
      return false;
  }
  public cardFooterLinksClick(event) {
    this.footerLinksClick.emit({ event });
    if (event.action == 'view_document' || event.action == 'view_tc') {
      this.baseService.getById(this.dataForCard[0].payer_id, 'payer', 'facility-management').subscribe(res => {
        let termDetails = {
          "fieldAction": "text",
          "item": res,
          "size": "sm",
          "title": "Terms and Conditions"
        }
        this.baseService.modalService.dialogService.open(PopUpOverGridWithControlsComponent, { size: DialogModalSize.Lg, data: event.action == 'view_document' ? res : termDetails }).afterClosed.subscribe(data => { }, err => { })
      })
    }
    if (event.action == 'view_ambulance') {
      let obj = {
        resource: 'view_ambulance_list',
        action: "LIST",
        banner: {
          "selector": "app-patient-layout",
          "datasource": {
            "application": "adt",
            "resource": "encounter_ipAdmission",
            "query_id": "GET_BY_ID"

          },
          "key": this.dataForCard
        }
      };
      this.smartModalService.open(PopupFormComponent, obj, 'Available Ambulances', ModalSize.Xl).subscribe(data => { }, err => { });
    }
    if (event.action == 'viewNoteBanner') {
      this.viewNote()
    }
    if (event.action == 'update_demographic' || event.action == 'update_registration') {
      this.showPatientData(event.action)
    }
    if(event.action == "VIEW_PATIENT_DETAILS"){
      this.viewPatientDetails()
    }
    if(event?.action == "view_bed_history"){
      this.showBedHistory();
    }
  }

  viewNote() { //view patient notes on click from banner
    let datasource = {
      resource: "self_note",
      application: "emr",
      args:  "uhId:" + this.dataForCard[0].uhId + ",encounter_id:" + this.dataForCard[0].encounter_id + ",episode:" + (this.dataForCard[0].encounter_id ? this.dataForCard[0].encounter_id : this.dataForCard[0].episode_id),
      filter: "status:Active",
      query_id: "GET_SELFNOTE_BY_USERID"
    }
    let capability = [{
      "action": "popup_form",
      "action_name": "UPDATE_INTERVENTION",
      "label": "field.label.intervention_details",
      "title": "Add Intervention",
      "dependent_fields2BindData": "id",
      "args": "id",
      "application": "emr",
      "resource": "self_note",
      "bannerData": this.dataForCard[0],
      "api_action": "MODIFY",
      "successMessage": "Intervention Added Successfully",
      "conditions": [
        {
            "expression": "item['status'] == 'Active' && contextMenu.bannerData.encounter_id == item['encounter_id']"
        }
      ],
      "form": {
          "blocks": [
              {
                  "name": "basic_information",
                  "class_name": "null",
                  "order": 1,
                  "layout_type": "one-column",
                  "fields": [
                      {
                        "label": "field.label.intervention_details",
                        "class_name": "kx-control col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 fix",
                        "order": 2,
                        "type": "String",
                        "required": true,
                        "hint": "field.hint.intervention_details",
                        "maxlength": 2400,
                        "component": "textarea",
                        "row": 3,
                        "name": "intervention"
                      }
                  ],
                  "title": ""
              }
          ]
      }
    }]
    let popobj1 = { data: { 'resource': "self_note", 'datasource': datasource, 'capability': capability}, title: 'Patient Note', size: DialogModalSize.Lg };
    this.dialogService.open(AdvanceSearchComponent, popobj1).afterClosed.subscribe(response => {});
  }

  getProfileData(file_id?) {
    this.selectedFiles = [];
    this.file_id = file_id;
    let documentResource = 'userImage' + '/image-byte-array';
    this.baseService.get(file_id, "", documentResource, 'dms').subscribe(
      (data: any) => {
        this.docData = data.imageData;
        let contentType = 'data:' + data.contentType + ';base64, ';
        let imagebase64 = contentType +data.imageData;
        this.imageURL = imagebase64;
        const fileVal = {
          imageSrc: imagebase64,
          file: {
            name: data.documentName,
            size: data.size,
            contentType: data.contentType
          }
        };
        this.selectedFiles.push(fileVal);
        //console.log("Profile Data",this.selectedFiles);
      }
    );
  }
  showImage(file: any) {
    if ((file.file.type != null && file.file.type.startsWith("image/")) || (file.file.contentType != null && file.file.contentType.startsWith("image/")))
      return true;
    else return false;
  }
  setclass(field, item, class_) {
    for (let val of field) {
      if (eval(val.expression)) {
        return class_ = val.class != undefined ? val.class : val.class_name ? val.class_name : '';
      }
    }
  }

  // For image upload Popup
  showUserImageUpload() {
    var data = { "id": this.id, "resource": this.resource }
    this.smartModalService.open(ImageUploadPopupComponent, data, "Upload Image", ModalSize.Md).subscribe(data => {
      if (data) {
        this.getProfileData(data.result);
      }
    }, err => {
      console.log("error occur");
    })
  }
  showPatientEmpData() {
    var object = {
      "data": this.dataForCard[0],
      "layout_type": "simple",
      "resource": "update_employer_details",
      "action": "MODIFY"
    }
    this.smartModalService.open(PopupFormComponent, object, "Update Employer Details", ModalSize.Xl).subscribe(
      res => {
        // object = result.result.resource[0];
        // this.baseService.action(object, "UPDATE_BASIC_DETAILS", "patient-registration", "patient").subscribe(
        //   res => {
        if (res.result.errCode == 0) {
          let currentUrl = this.router.url;
          this.router.navigate([this.route.snapshot.queryParams.returnUrl], { skipLocationChange: true }).then(() => {
            this.router.navigateByUrl(currentUrl);
          });
        }
        else if (res.result.errCode == -1) {
          this.alerts.error(res.result.message);
        }
        // })
      },
      err => {
      })
  }
  showPatientData(action?) {
    if (this.bannerJson.datasource.resource == "service_request" || (this.action == 'ADD' && (this.resource == "encounter_ipAdmission" || this.resource == "encounter_erAdmission" || this.resource == "encounter_dcAdmission"))) {
      var object = {
        "data": this.dataForCard[0],
        "layout_type": "simple",
        "resource": action == "update_registration" ? "patient" : "op_update",
        "action": "MODIFY"
      }
    }
    else if (this.action == 'MODIFY' && (this.resource == "encounter_ipAdmission" || this.resource == "encounter_erAdmission" || this.resource == "encounter_dcAdmission")) {
      let data = { args: "id:" + (this.dataForCard[0] && this.dataForCard[0].patient_id ? this.dataForCard[0].patient_id : '') }
      this.baseService.getData(data, "", "patient", "patient-registration", "GET_BY_ID").subscribe((res: any) => {
        if (res.errCode == -1) {
          this.alerts.error(res.message);
        } else {
          if (res.resource && res.resource.length > 0) {
            var object = {
              "data": res.resource[0],
              "layout_type": "simple",
              "resource": action == "update_registration" ? "patient" : "op_update",
              "action": "MODIFY"
            }
            this.updatePatientDetailPopup(object);
          }
        }
      })
    }
    else {
      var object = {
        "data": this.dataForCard[0],
        "layout_type": "simple",
        "resource": "patient_update",
        "action": "MODIFY"
      }
    }
    if (this.resource == 'pre_registration') {
      var object = {
        "data": this.dataForCard[0],
        "layout_type": "simple",
        "resource": "pre_registration_update",
        "action": "MODIFY"
      }
    }
    if (this.bannerJson.datasource.resource != "encounter_ipAdmission" && this.bannerJson.datasource.resource != "encounter_erAdmission" && this.bannerJson.datasource.resource != "encounter_dcAdmission")
      this.updatePatientDetailPopup(object);
  }
  updatePatientDetailPopup(object) {
    this.smartModalService.open(PopupFormComponent, object, "Update Patient Details", ModalSize.Xl).subscribe(
      res => {
        if (res.result.errCode == 0) {
          let currentUrl = this.router.url;
          this.router.navigate([this.route.snapshot.queryParams.returnUrl], { skipLocationChange: true }).then(() => {
            this.router.navigateByUrl(currentUrl);
          });
        }
        else if (res.result.errCode == -1) {
          this.alerts.error(res.result.message);
        }
      },
      err => {
      })
  }
  expandCards() {
    if (this.expandCard) {
      this.expandCard = false;
    }
    else {
      this.expandCard = true;
      this.bannerJson.oldWidth = this.elementView.nativeElement.offsetWidth;
    }
    this.elementInfo.emit({ "event": this.elementView.nativeElement, "expandCard": this.expandCard });

    let IPPharmacyBannerAmount = false;
    IPPharmacyBannerAmount = this.appService.getAccountConfigValue('enable_ip_pharmacy_banner_amount') != undefined;
    if (IPPharmacyBannerAmount && this.expandCard && this.bannerJson.PharmacyScreenIPAmount) {
      const bannerData = this.bannerJson.PharmacyScreenIPAmount;
      const args = `uhId:${this.dataForCard[0].uhId},admissionId:${this.dataForCard[0].encounter_id},from:banner`;
      this.cacheObj = args + bannerData.query_id + bannerData.resource + bannerData.application + "PharmacyIPAmount";
      const cacheKey = CryptoJS.MD5(this.cacheObj).toString();
      this.pharmacyCacheKey = cacheKey;

      const cachedData = this.baseService.getCachedData(cacheKey);
      if (cachedData) {
        this.setPharmacyAmountsR(cachedData);
      } else {
        this.loaderService.showSpinner();
        this.baseService.get(
          bannerData.query_id, args, bannerData.resource, bannerData.application).subscribe(
          (res: any) => {
            // this.loaderService.hideSpinner();
            if (res.errCode === 0 && res.resource?.[0]) {
              this.baseService.setCachedData(cacheKey, res.resource[0]);
              this.setPharmacyAmountsR(res.resource[0]);
            } else {
              this.loaderService.hideSpinner();
              console.warn('IP Pharmacy amounts not available');
            }
          },
          (error) => {
            this.loaderService.hideSpinner();
            console.error('Error fetching pharmacy amounts:', error);
          }
        );
      }
    }
    // if (this.expandCard && this.bannerJson.AvailableCashNetAmount) {
    //   if (this.baseService != undefined) {
    //     this.baseService.get('GET_CONFIG', 'module_code:payment,config_code:payment_149', 'facility_config_mapping', 'facility-management').subscribe(
    //       result => {
    //         if (result.errCode == 0 && result.resource.length > 0 && result.resource[0].config_value != undefined && result.resource[0].config_value != "") {
    //           const bannerData = this.bannerJson.AvailableCashNetAmount;
    //           const args = `uhId:${this.dataForCard[0].uhId}`;
    //           this.cacheObj = args + bannerData.query_id + bannerData.resource + bannerData.application + "AvailableCashNetAmount";
    //           const cacheKey = CryptoJS.MD5(this.cacheObj).toString();
    //           this.cashCacheKey = cacheKey;
    //           const cacheData = this.baseService.getCachedData(cacheKey);
    //           if (cacheData) {
    //             //Cache HIT
    //             this.setPharmacyCashAmount(cacheData);
    //           } else {
    //             // Cache MISS → API call
    //             this.baseService.get(bannerData.query_id, args, bannerData.resource, bannerData.application).subscribe(
    //               (res: any) => {
    //                 if (res.errCode == 0 && res.resource?.length > 0) {
    //                   //Store in cache
    //                   this.baseService.setCachedData(cacheKey, res.resource[0]);
    //                   this.setPharmacyCashAmount(res.resource[0]);
    //                 }
    //               })
    //           }

    //         }
    //       });
    //   }


    // }
  }

  private setPharmacyAmountsR(data: any): void {
    const pharmacyIpAmounts = {
      pharmacy_due: data.pharmacy_due || 0,
      pharmacy_refund: data.pharmacy_refund ? `-${data.pharmacy_refund}` : 0,
      pharmacy_deposit_available: data.pharmacy_deposit_available || 0,
      total_amount: data.total_amount || 0
    };
    this.dataForCard[0] = {
      ...this.dataForCard[0],
      ...pharmacyIpAmounts
    };
    if (!this.bannerJson.supportingFields) {
      const bannerData = this.bannerJson.PharmacyScreenIPAmount;
      this.bannerJson.supportingFields = bannerData.supporting_banner || {};
      this.supportingFields = this.bannerJson.supportingFields.fields.sort((a, b) => { return a.order - b.order });
      this.supportingFields = [...this.bannerJson.supportingFields.fields];
    }
    setTimeout(() => {
      this.loaderService.hideSpinner();
    }, 0);
  }

  //  private setPharmacyCashAmount(data: any): void {
  //   const cashAmountFields = {
  //     netAmount: data.netAmount || 0,
  //   };
  //   this.dataForCard[0] = {
  //     ...this.dataForCard[0],
  //     ...cashAmountFields
  //   };
  //   //  if (this.bannerJson.supportingFields?.fields?.length > 0) {
  //   //    //Already exists → merge
  //   //    const netAmountFields = this.bannerJson?.AvailableCashNetAmount?.supporting_banner?.fields || [];
  //   //    const existingFields = this.bannerJson.supportingFields.fields;

  //   //    this.bannerJson.supportingFields.fields = [
  //   //      ...existingFields,
  //   //      ...netAmountFields
  //   //    ];
  //   //    // Remove duplicates if any
  //   //    this.bannerJson.supportingFields.fields = this.bannerJson.supportingFields.fields.filter(
  //   //      (field, index, self) =>
  //   //        index === self.findIndex(f => f.name === field.name)
  //   //    );
  //   //   //  this.supportingFields = this.bannerJson.supportingFields.fields.sort((a, b) => { return a.order - b.order });
  //   //   //  this.supportingFields = [...this.bannerJson.supportingFields.fields];
  //   //    const netAmountFieldNames = netAmountFields.map(f => f.name);

  //   //    this.supportingFields = [...this.bannerJson.supportingFields.fields.filter(f => !netAmountFieldNames.includes(f.name)).sort((a, b) => a.order - b.order),
  //   //      ...this.bannerJson.supportingFields.fields.filter(f => netAmountFieldNames.includes(f.name)).sort((a, b) => a.order - b.order)
  //   //    ];
  
  //   //  }
  //   if (this.bannerJson.supportingFields?.fields?.length > 0) {

  //   // Already exists → merge properly
  //   const netAmountFields = this.bannerJson?.AvailableCashNetAmount?.supporting_banner?.fields || [];

  //   const existingFields = this.bannerJson.supportingFields.fields || [];

  //   // Creating a map of existing fields by name for efficient lookup and replacement
  //   const fieldMap = new Map();

  //   existingFields.forEach(field => {
  //     fieldMap.set(field.name, field);
  //   });

  //   // Add or replace with new fields
  //   netAmountFields.forEach(field => {
  //     fieldMap.set(field.name, field);
  //   });

  //   // Convert map back to array and sort by order
  //   this.bannerJson.supportingFields.fields = Array.from(fieldMap.values()).sort(
  //     (a, b) => a.order - b.order
  //   );

  //   // Move Available Cash Amount field(s) to the end
  //   const netAmountFieldNames = netAmountFields.map(f => f.name);

  //   this.supportingFields = [...this.bannerJson.supportingFields.fields.filter(f => !netAmountFieldNames.includes(f.name)).sort((a, b) => a.order - b.order),...this.bannerJson.supportingFields.fields.filter(f => netAmountFieldNames.includes(f.name)).sort((a, b) => a.order - b.order)];

  //   // Keep bannerJson fields in same order as supportingFields
  //   this.bannerJson.supportingFields.fields = [...this.supportingFields];
  // }
  //    else {
  //      if (!this.bannerJson.supportingFields) {
  //        const bannerData = this.bannerJson.AvailableCashNetAmount;
  //        this.bannerJson.supportingFields = bannerData.supporting_banner || {};
  //        this.supportingFields = this.bannerJson.supportingFields.fields.sort((a, b) => { return a.order - b.order });
  //        this.supportingFields = [...this.bannerJson.supportingFields.fields];
  //      }
  //    }
  // }



  hidePopUp() {
    jQuery("popover-container").hide();
  }

  getDataOnIVF(ivf_no:any,cb){
    this.loaderService.showSpinner()
    this.baseService.get("GET_PATIENT_BY_IVF_NO","ivf_no:"+ivf_no,"ivf_patient","patient-registration").subscribe((response:any)=>{
      this.loaderService.hideSpinner()
      if(response.errCode === 0){
        cb(response.resource[0]);
      }else{
        cb(false)
      }
    })
  }
  generateVisit(ivf) {
    // console.log(this.artPatientLayoutService.primaryServiceRequestId)
    // sessionStorage.setItem("demo_ivf_no",ivf.ivf_no)
    let serviceRequestId = this.artPatientLayoutService?.primaryServiceRequestId || JSON.parse(sessionStorage.getItem('primaryDetails') || '{}')?.serviceRequestId;
     const currentTab0 = this.route.snapshot?.queryParams['tab_0'];
    if(currentTab0)
    {
      if (ivf.visitButtonLabel === 'Prescription Is Final') {
        // this.artPatientLayoutService.createVisit(ivf, serviceRequestId, currentTab0);
       }
     else if (ivf.visitButtonLabel === 'Generate Visit') {
       this.artPatientLayoutService.createVisit(ivf, serviceRequestId, currentTab0);
     } else {
       this.artPatientLayoutService.handleVisitData(ivf, currentTab0);
     }
   }
   }
  routeIVF(ivf) {
    this.getDataOnIVF(ivf.ivf_no,(result)=>{
      if(result){
        sessionStorage.setItem("currentData",JSON.stringify(result));
        const prev = this.router.routeReuseStrategy.shouldReuseRoute;
        const prevOSN = this.router.onSameUrlNavigation;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        let query_params = "uhId:" + ivf.uhId + ",ivf_no:" + ivf.ivf_no;
        this.router.navigate([window.location.pathname], { queryParams: { query_params: query_params, banner: this.route.snapshot.queryParams.banner, returnUrl: this.route.snapshot.queryParams.returnUrl, key: ivf.patient_id } });
        setTimeout(() => {
          this.router.routeReuseStrategy.shouldReuseRoute = prev;
          this.router.onSameUrlNavigation = prevOSN;
        }, 0);
      }else{

      }
    })
  }
  configureBanner(config) {
    if(this.bannerJson.jsonName != undefined){
      var obj: any = {};
      obj = { ...obj, ...config };
      obj["key"] =  "account__"+this.preferenceService.getBannerPreferenceKey(this.bannerJson.jsonName);
      obj["resource_name"] = this.bannerJson.jsonName;
      obj["context"] = "banner";
      obj["bannerJson"] = this.bannerJson;
      obj["jsonFields"] = this.jsonFields;
      if(this.bannerJson && this.bannerJson.supportingFields && this.bannerJson.supportingFields.fields && this.bannerJson.supportingFields.fields.length > 0){
        obj["jsonFields"] = [...(this.jsonFields || []), ...this.bannerJson.supportingFields.fields];
      }
      this.preferenceService.openConfigurePopup(obj, (response) => {
        if (response.result != undefined) {
  
          this.preferenceService.saveConfigurationData(obj, response.result, (result) => {
            console.log(result);
            //re-apply so comma config reflects without reload (new refs for pure mapvalue pipe)
            //this.getBannerPreference(() => this.jsonFields = this.jsonFields.map(json => ({ ...json })));
          });
        }
      });
    }else{
      console.error("banner json name not found");
    }
  }
  getFieldValue(data: any, field: any) {
    if (!data || !field) return '';
    //  nested path (field.name)
    if (data[field.name]) {
      return data[field.name]
    }
    const value = field.name?.split('.')?.reduce((o, key) => o?.[key], data);
    if (value !== undefined && value !== null) {
      return value;
    }
    //  label (convert to key)
    const labelKey = field.label?.toLowerCase()
    return data?.[labelKey] ?? '';
  }
  checkBannerCityVisibilityConfig() {
    if (this.dataForCard && Array.isArray(this.dataForCard) && this.dataForCard.length > 0) {
      let gridData = {
        "args": "uhId:" + this.dataForCard[0]?.uhId,
        "query_id": 'GET_PATIENT_BY_UHID'
      }
      this.baseService.getData(gridData, '', 'patient', 'patient-registration', 'GET_PATIENT_BY_UHID').subscribe(response => {
        if (response.resource && response.resource.length > 0) {
          // cardData = { ...result, ...response.resource[0] };
          if (response.resource[0]?.otherDetails?.occupation) {
            this.dataForCard[0]['occupation'] = response.resource[0]?.otherDetails?.occupation
          }
          if (!this.dataForCard[0]['city']) {
            this.dataForCard[0]['city'] = response.resource[0]?.address?.cityDisplayName
          }
          if (!this.dataForCard[0]['state']) {
            this.dataForCard[0]['state'] = response.resource[0]?.address?.stateDisplayName
          }
          //this.dataForCard=[...this.dataForCard]
        } else {
          // cardData = result;
        }
      })
    }
  }
  shouldButtonVisible(btn: any) {
    if (this.bannerJson?.shouldInfoDisplay == true && !this.bannerJson.name && !this.bannerJson.jsonFields) {
      // return true
      if (this.bannerJson?.additionalResource) {
        return this.rolePermissionService.checkAccessPermission(
          btn.action_name,
          this.bannerJson.additionalResource,
          this.bannerJson?.datasource?.application
        )
      }
    }
    let res;
    res = this.rolePermissionService.checkAccessPermission(
      btn.action_name,
      this.bannerJson.jsonName
    )
    if (res) {
      return res;
    }
    if(this?.bannerJson?.datasource?.application)
    {
    res = this.rolePermissionService.checkAccessPermission(
      btn.action_name,
      this.bannerJson.jsonName,
      this.bannerJson.datasource.application
    )
    if (res) {
      return res;
    }
   }
  //  if (this?.bannerJson?.jsonName == 'banner_ip_emr' && this?.bannerJson?.datasource?.application == 'adt') {
  //     return true
  //   }
    return res;
  }

  extraButtonClick(btn){
    if (btn.type == 'additional_info') {
      if (this.utilService.isMobile() && btn.showPopover) {
        if (this.dataForCard && Array.isArray(this.dataForCard) && this.dataForCard.length > 0) {
          let gridData = {
            "args": "uhId:" + this.dataForCard[0]?.uhId,
            "query_id": 'GET_PATIENT_BY_UHID'
          }
          this.loaderService.showSpinner();
          this.baseService.getData(gridData, '', 'patient', 'patient-registration', 'GET_PATIENT_BY_UHID').subscribe(response => {
            this.loaderService.hideSpinner();
            if (response.resource && response.resource.length > 0) {
              if (response.resource[0]?.otherDetails?.occupation) {
                this.dataForCard[0]['occupation'] = response.resource[0]?.otherDetails?.occupation
              }
              if (!this.dataForCard[0]['city']) {
                this.dataForCard[0]['city'] = response.resource[0]?.address?.cityDisplayName
              }
              if (!this.dataForCard[0]['state']) {
                this.dataForCard[0]['state'] = response.resource[0]?.address?.stateDisplayName
              }
            }
            let htmlContent = '<div class="total-text-container additional-details-popup" style="padding: 15px;"><div class="d-flex flex-column">';
            if (btn.fields) {
              for (let field of btn.fields) {
                let value = this.getFieldValue(this.dataForCard[0], field);
                htmlContent += `
                  <div class="total-text-container d-flex mb-2">
                    <div class="employee-label" style="width: 140px; font-weight: bold; font-size: 14px;">${field.label}</div>
                    <div class="employee-col px-2">:</div>
                    <div class="employee-rel" style="flex: 1; font-size: 14px; color: #333;">${value || ''}</div>
                  </div>`;
              }
            }
            htmlContent += '</div></div>';
            
            let obj = {
              title: "Patient Info",
              data: {
                message: htmlContent
              }
            };
            if (this.dialogService) {
              this.dialogService.open(HealthAnalysisComponent, obj).afterClosed.subscribe(response => {});
            }
          }, err => {
            this.loaderService.hideSpinner();
          });
        }
      } else {
        this.checkBannerCityVisibilityConfig();
      }
    }
    if(btn.type == 'health_analysis'){
      this.loaderService.showSpinner();
      this.baseService.action({uhId: this.dataForCard[0].uhId}, "HEALTH_ANALYSIS", "data-onboarding", "health_analysis").subscribe(res=>{
        this.loaderService.hideSpinner();
        if(res.errCode == 0 && res.resource && res.resource.length > 0 && res.resource[0].health_analysis_dashboard){
          let obj = {
            "data": {
              "message": res.resource[0].health_analysis_dashboard
            }
          }
          this.dialogService.open(HealthAnalysisComponent, obj).afterClosed.subscribe(response => {
          })
        }
      })
    }
 if(btn.type == 'cash_info'){
   const args = `uhId:${this?.dataForCard[0].uhId}`;
   this.loaderService.showSpinner();
   // Checking facility config before fetching cash collection
   if (this.baseService != undefined) {
  this.baseService.get('GET_CONFIG', 'module_code:payment,config_code:payment_149', 'facility_config_mapping', 'facility-management').subscribe(result => {
     if (result && result.errCode == 0 && result.resource && result.resource.length > 0 && result.resource[0].config_value != undefined && result.resource[0].config_value != "") {
       // Config enabled → fetch cash collection
       this.baseService.get('GET_CASH_COLLECTION', args, 'user_collection_detail', 'payment').subscribe((res: any) => {
         this.loaderService.hideSpinner();
         if (res.resource && res.resource.length > 0) {
           if (res.resource[0]?.netAmount != undefined && res.resource[0]?.netAmount > 0) {
             this.dataForCard[0]['netAmount'] = res.resource[0]?.netAmount
           }
           else{
             this.dataForCard[0]['netAmount'] = 0;
           }
         }
       }, err => {
         this.loaderService.hideSpinner();
       });
     } else {
       // Config disabled or not present → ensure spinner hidden and clear netAmount
       this.loaderService.hideSpinner();
      //  this.dataForCard[0]['netAmount'] = 0;
     }
   }, err => {
     this.loaderService.hideSpinner();
   });
   }
 
 }
}


  getBannerPreference(cb?){
    if(this.bannerJson.jsonName != undefined){
      this.preferenceService.getBannerPreference(this.config,this.bannerJson.jsonName,()=>{
        this.config.configLoaded = true;
        if (cb && typeof cb == 'function') cb();
      }, this.jsonFields?.length ? (this.jsonFields && this.supportingFields ? [...this.jsonFields, ...this.supportingFields]: this.jsonFields) :  this.bannerJson.jsonFields?.fields && this.bannerJson.supportingFields?.fields ? [...this.bannerJson.jsonFields.fields, ...this.bannerJson.supportingFields.fields] : this.bannerJson.jsonFields?.fields);
    }else{
      console.error("banner json name not found");
    }
  }

  ngOnDestroy() {
    this.communicationService.emitChange({ hideMenuIcon: false });
    document.getElementById("core-body").classList.remove('_pb-tags');
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
    if (this.pharmacyCacheKey && this.baseService.cacheObj) {
      delete this.baseService.cacheObj[this.pharmacyCacheKey];
    }
    if (this.cashCacheKey && this.baseService.cacheObj) {
    delete this.baseService.cacheObj[this.cashCacheKey];
  }
  if(!this.router.url.includes('emr_op_patient')&& this.bannerJson?.key?.emr_type_flow_code &&this.bannerJson?.key?.emr_type_flow_code=='art_consultation'){
      this.artPatientLayoutService.removeArtPatientData()
    }
  }
  maskingIdentity(number) {
    if(number.length > 4){
      const firstTwoDigits = number.slice(number.length-4, number.length);
      const remainingLength = number.length - 4;
      const xString = 'X'.repeat(remainingLength);
      return xString + firstTwoDigits;
    }
    else
      return number
  }
  isSeroPositive(tagData: any[]): boolean {
    if (!tagData) return false;
    if (!Array.isArray(tagData)) return false;

    return tagData.some(tag => tag.key_name === 'sero_status' && tag.key_value_code === 'Yes');
  }

  //show the report icon only when the report is completed but has not been seen yet
  isDiagnosticReportFinalUnseen(data: any): boolean {
    if (!data) return false;
    return data.report_completed_status == 'Y' && data.report_seen_status != 'Y';
  }

  //rows for an info_popover config: popoverConfig.fields iterate over data[popoverConfig.arrayField] when type is 'array' (optionally filtered via popoverConfig.filter_expression), else over data itself
  //arrayField may be a single key or a list of candidate keys, tried in order, so a config can name a fallback field (e.g. ["payer_details", "billingpayer_details"]) when data shapes differ by resource
  getPopoverRows(data: any, popoverConfig: any): any[] {
    if (popoverConfig?.type != 'array') {
      return data ? [data] : [];
    }
    const arrayFields = Array.isArray(popoverConfig.arrayField) ? popoverConfig.arrayField : [popoverConfig.arrayField];
    const arrayField = arrayFields.find((f: string) => Array.isArray(data?.[f]));
    const arr = arrayField ? data[arrayField] : [];
    return popoverConfig.filter_expression ? arr.filter((item: any) => this.getValue(popoverConfig.filter_expression, item)) : arr;
  }
  //whether an info_popover config resolves to any actual content for data - popoverConfig.expression (optional) gates visibility first, then at least one row must have a non-empty format/field value
  hasPopoverData(data: any, popoverConfig: any): boolean {
    if (popoverConfig?.expression && !this.getValue(popoverConfig.expression, data)) {
      return false;
    }
    return this.getPopoverRows(data, popoverConfig).some((row: any) => popoverConfig.format
      ? !!this.getFormattedValue(popoverConfig.format, row)
      : (popoverConfig.fields || []).some((field: any) => !!this.getFieldValue(row, field)));
  }
  //evaluates a "(item) => ..." format string against a row
  getFormattedValue(format: string, item: any) {
    try {
      return format ? eval(format)(item) : '';
    } catch (e) {
      return '';
    }
  }
}
